var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [_vm._v("筛选查询")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: {
                        type: "text",
                        icon: _vm.filterFold
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      },
                      on: { click: _vm.toggleFilter }
                    },
                    [_vm._v(_vm._s(_vm.filterFold ? "展开筛选" : "收起筛选"))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px 25px" } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form",
                              {
                                staticClass: "demo-form-inline",
                                attrs: { inline: true, model: _vm.form }
                              },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "输入搜索：" } },
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "商家" },
                                      nativeOn: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.search.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.form.supply_name,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "supply_name", $$v)
                                        },
                                        expression: "form.supply_name"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          placeholder: "代采组",
                                          filterable: ""
                                        },
                                        model: {
                                          value: _vm.form.pgid,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "pgid", $$v)
                                          },
                                          expression: "form.pgid"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "全部", value: "0" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(_vm.search_ops.pg_list, function(
                                          item
                                        ) {
                                          return _c("el-option", {
                                            key: item.pgid,
                                            attrs: {
                                              label: item.pgname,
                                              value: item.pgid
                                            }
                                          })
                                        })
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          placeholder: "代采组员",
                                          filterable: ""
                                        },
                                        model: {
                                          value: _vm.form.pg_member_id,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "pg_member_id",
                                              $$v
                                            )
                                          },
                                          expression: "form.pg_member_id"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "全部", value: "0" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.search_ops.memberOption,
                                          function(item) {
                                            return _c("el-option", {
                                              key: item.value,
                                              attrs: {
                                                label: item.label,
                                                value: item.value
                                              }
                                            })
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "城市" },
                                        model: {
                                          value: _vm.form.city,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "city", $$v)
                                          },
                                          expression: "form.city"
                                        }
                                      },
                                      _vm._l(_vm.search_ops.city, function(
                                        item
                                      ) {
                                        return _c("el-option", {
                                          key: item.key,
                                          attrs: {
                                            label: item.label,
                                            value: item.key
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          placeholder: "一级市场",
                                          filterable: ""
                                        },
                                        on: { change: _vm.setChild },
                                        model: {
                                          value: _vm.form.father_market_id,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "father_market_id",
                                              $$v
                                            )
                                          },
                                          expression: "form.father_market_id"
                                        }
                                      },
                                      _vm._l(_vm.search_ops.market, function(
                                        item
                                      ) {
                                        return _c("el-option", {
                                          key: item.key,
                                          attrs: {
                                            label: item.label,
                                            value: item.key
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          placeholder: "二级市场",
                                          multiple: "",
                                          filterable: ""
                                        },
                                        model: {
                                          value: _vm.form.market_id,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "market_id", $$v)
                                          },
                                          expression: "form.market_id"
                                        }
                                      },
                                      _vm._l(
                                        _vm.search_ops.child_market,
                                        function(item) {
                                          return _c("el-option", {
                                            key: item.key,
                                            attrs: {
                                              label: item.label,
                                              value: item.key
                                            }
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "状态" },
                                        model: {
                                          value: _vm.form.swb_status,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "swb_status",
                                              $$v
                                            )
                                          },
                                          expression: "form.swb_status"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "全部", value: "0" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.search_ops.swb_status,
                                          function(item) {
                                            return _c("el-option", {
                                              key: item.key,
                                              attrs: {
                                                label: item.label,
                                                value: item.key
                                              }
                                            })
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "生成日期：" } },
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        "default-time": [
                                          "00:00:00",
                                          "23:59:59"
                                        ],
                                        type: "datetimerange",
                                        "value-format": "yyyy-MM-dd HH:mm:ss",
                                        "range-separator": "至",
                                        "start-placeholder": "开始日期",
                                        "end-placeholder": "结束日期"
                                      },
                                      model: {
                                        value: _vm.form.create_time,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "create_time", $$v)
                                        },
                                        expression: "form.create_time"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: { click: _vm.search }
                                      },
                                      [_vm._v("查询")]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.loading
        ? _c(
            "el-row",
            [
              _c(
                "el-col",
                { staticStyle: { border: "1px solid #ddd" } },
                [
                  _c(
                    "el-row",
                    {
                      staticStyle: {
                        background: "#f3f3f3",
                        height: "50px",
                        "line-height": "30px",
                        padding: "0 25px",
                        display: "flex",
                        "align-items": "center"
                      },
                      attrs: { span: 24 }
                    },
                    [
                      _c("el-col", { attrs: { span: 8 } }, [
                        _vm._v("数据列表：")
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "text-align": "right" },
                          attrs: { span: 16 }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", size: "mini" },
                              on: { click: _vm.dabiao }
                            },
                            [_vm._v("\n            待回货商品前置打标")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "success", size: "mini" },
                              on: { click: _vm.output }
                            },
                            [_vm._v("\n            导出")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.resData
                    ? _c(
                        "div",
                        { staticStyle: { "margin-bottom": "0" } },
                        [
                          _c(
                            "el-table",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.tableLoading,
                                  expression: "tableLoading"
                                }
                              ],
                              ref: "multipleTable",
                              staticStyle: { width: "100%" },
                              attrs: {
                                height: "800",
                                data: _vm.resData.list,
                                "tooltip-effect": "dark"
                              },
                              on: {
                                "selection-change": _vm.handleSelectionChange
                              }
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  type: "selection",
                                  width: "50",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "create_day",
                                  label: "生成日期",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "supply_id",
                                  label: "商家ID",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "supply_name",
                                  label: "商家",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "supply_city",
                                  label: "城市",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "father_market",
                                  label: "一级市场",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "market",
                                  label: "二级市场",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "pgname",
                                  label: "代采组",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "member",
                                  label: "代采员",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "all_num",
                                  label: "待回货",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "supply_wait_back_swb_status",
                                  label: "状态",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "operator_names",
                                  label: "打标人",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "operator_dates",
                                  label: "打标时间",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.resData
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            "text-align": "right",
                            padding: "25px"
                          }
                        },
                        [
                          _c("el-pagination", {
                            attrs: {
                              "current-page": _vm.curPage,
                              background: "",
                              layout: "total, prev, pager, next, jumper ,sizes",
                              total: _vm.resData.count,
                              "page-size": _vm.form.pagesize,
                              "page-sizes": [50, 100, 200, 500]
                            },
                            on: {
                              "update:currentPage": function($event) {
                                _vm.curPage = $event
                              },
                              "update:current-page": function($event) {
                                _vm.curPage = $event
                              },
                              "current-change": _vm.handleCurrentChange,
                              "size-change": _vm.handleSizeChange
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b24e04e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b24e04e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/supplywaitback/SupplyWaitBackList.vue
// module id = null
// module chunks = 